import { makeStyles, Radio } from '@material-ui/core';
import { ReactComponent as UncheckedIcon } from '../../../../static/images/uncheckedIcon.svg';
import { ReactComponent as CheckedIcon } from '../../../../static/images/checkedIcon.svg';

const useStyles = makeStyles((theme) => ({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
  },
}));

const AdmissionRadio = (params) => {
  const classes = useStyles();
  return (
    <Radio
      {...params}
      icon={<UncheckedIcon className={classes.icon} />}
      checkedIcon={<CheckedIcon className={classes.icon} />}
    >
      {params.children}
    </Radio>
  );
};

export default AdmissionRadio;
